export const convertComlexLabel = (label: string | undefined) => {
  if (!label) return null;
  if (label.includes('COMLEX 1')) {
    return 'COMLEX 1 OMM Supplement';
  } else if (label.includes('COMLEX 2')) {
    return 'COMLEX 2 OMM Supplement';
  } else if (label.includes('COMLEX 3')) {
    return 'COMLEX 3 OMM Supplement';
  }
  return label;
};
